
    export default 
    {
    "publicDocument": {
        "warn": "Unser System hat festgestellt, dass das Passwort zu einfach zu knacken ist. Bitte gehen Sie zu Einstellungen-Konto, um das Passwort nach dem Einloggen zurückzusetzen.",
        "newPass": "Bitte geben Sie ein neues Passwort ein.",
        "safety": "Das Passwort ist nicht sicher.",
        "scope": ""
    }
}